var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, cloneElement, isValidElement, useContext } from 'react';
import KeyCode from 'rc-util/lib/KeyCode';
import classNames from 'classnames';
import OutlinedExclamationCircle from 'acud-icon/lib/icons/OutlinedExclamationCircle';
import Tooltip from '../tooltip';
import { ConfigContext } from '../config-provider';
import { getTransitionName } from '../_util/motion';
import useMergedState from '../_util/hooks/useMergedState';
import { Overlay } from './PurePanel';
const Popconfirm = forwardRef((props, ref) => {
    const { getPrefixCls } = useContext(ConfigContext);
    const [visible, setVisible] = useMergedState(false, {
        value: props.visible,
        defaultValue: props.defaultVisible
    });
    const settingVisible = (value, e) => {
        var _a;
        setVisible(value);
        (_a = props.onVisibleChange) === null || _a === void 0 ? void 0 : _a.call(props, value, e);
    };
    const close = (e) => {
        settingVisible(false, e);
    };
    const onConfirm = (e) => { var _a; return (_a = props.onConfirm) === null || _a === void 0 ? void 0 : _a.call(this, e); };
    const onCancel = (e) => {
        var _a;
        settingVisible(false, e);
        (_a = props.onCancel) === null || _a === void 0 ? void 0 : _a.call(this, e);
    };
    const onKeyDown = (e) => {
        if (e.keyCode === KeyCode.ESC && visible) {
            settingVisible(false, e);
        }
    };
    const onVisibleChange = (value) => {
        const { disabled } = props;
        if (disabled) {
            return;
        }
        settingVisible(value);
    };
    const { prefixCls: customizePrefixCls, placement, children, overlayClassName } = props, restProps = __rest(props, ["prefixCls", "placement", "children", "overlayClassName"]);
    const prefixCls = getPrefixCls('popover', customizePrefixCls);
    const prefixClsConfirm = getPrefixCls('popconfirm', customizePrefixCls);
    const overlayClassNames = classNames(prefixClsConfirm, overlayClassName);
    const rootPrefixCls = getPrefixCls();
    return (<Tooltip {...restProps} prefixCls={prefixCls} placement={placement} onVisibleChange={onVisibleChange} visible={visible} overlay={<Overlay okType={props.okType} icon={props.icon} {...props} prefixCls={prefixCls} close={close} onConfirm={onConfirm} onCancel={onCancel}/>} overlayClassName={overlayClassNames} ref={ref} transitionName={getTransitionName(rootPrefixCls, 'zoom-big', props.transitionName)}>
            {isValidElement(children)
            && cloneElement(children, {
                onKeyDown: (e) => {
                    var _a, _b;
                    if (isValidElement(children)) {
                        (_b = children === null || children === void 0 ? void 0 : (_a = children.props).onKeyDown) === null || _b === void 0 ? void 0 : _b.call(_a, e);
                    }
                    onKeyDown(e);
                }
            })}
        </Tooltip>);
});
Popconfirm.defaultProps = {
    placement: 'top',
    trigger: 'click',
    okType: 'primary',
    icon: <OutlinedExclamationCircle />,
    okText: '确定',
    cancelText: '取消',
    disabled: false
};
export default Popconfirm;
